import { createElementBlock, openBlock, createElementVNode } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
};
function render(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M23 13a3 3 0 0 1-3 3h-7.5a.5.5 0 0 1-.5-.5V8.025a.47.47 0 0 1 .226-.41 4.502 4.502 0 0 1 6.595 2.624A3 3 0 0 1 23 13M10 7.75a.75.75 0 0 1 .75.75v7a.75.75 0 1 1-1.5 0v-7a.75.75 0 0 1 .75-.75m-5.333 2a.75.75 0 0 1 .75.75v5a.75.75 0 0 1-1.5 0v-5a.75.75 0 0 1 .75-.75m2.666 1a.75.75 0 0 1 .75.75v4a.75.75 0 0 1-1.5 0v-4a.75.75 0 0 1 .75-.75M2.75 12a.75.75 0 0 0-1.5 0v2.5a.75.75 0 0 0 1.5 0z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const brandMusicSoundcloud = { render };
export {
  brandMusicSoundcloud as default,
  render
};
//# sourceMappingURL=brand-music-soundcloud.svg.js.map
